<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :goodsNumber="goodsNumber" :tabbarIndex="1"></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main">
      <div class="df-maina-ddtit"><span>批量导入订单详情</span></div>
      <div class="goBack">
        <el-button
          size="small"
          style="width:90px;background:#9cbbd8;color:#fff;position:relative;z-index:999;"
          @click="goBack"
        >
          返 回
        </el-button>
      </div>
      <div class="bottom" v-if="currentPageInfo.length > 0">
        <div class="info" v-for="(item, index) of currentPageInfo" :key="index">
          <div class="df-ordertit">
            <span>{{ index + 1 }}.子订单信息</span>
          </div>
          <div class="middle">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">订单创建时间:</div>
                <div class="right">{{ item.createTime || "暂无" }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">订单状态:</div>
                <div class="right right1">
                  {{ order_status(item.status) }}
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">订单编号:</div>
                <div class="right">{{ item.orderNum || "暂无" }}</div>
                <div class="copy hands" @click="copyText(item.orderNum)">
                  复制
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">运费:</div>
                <div class="right">{{ to_f(item.moneyYun || "0.00") }}</div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">商品费用:</div>
                <div class="right">{{ to_f(item.moneyGoods || "0.00") }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">总金额:</div>
                <div class="right">{{ to_f(item.money || "0.00") }}</div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货人:</div>
                <div class="right">{{ item.consignee || "暂无" }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">联系方式:</div>
                <div class="right">{{ item.consigneePhone || "暂无" }}</div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货地址:</div>
                <!-- <div class="right">{{ item.province + item.city + item.area + item.consigneeAddr || '暂无' }}</div> -->
                <div class="right">
                  {{
                    (item.province || "") +
                      (item.city || "") +
                      (item.area || "") +
                      (item.consigneeAddr || "暂无")
                  }}
                </div>
              </div>
            </div>

            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">快递方式:</div>
                <div class="right">
                  <!--{{ item.deliveryName || "" }}-->

                  <el-select
                    v-model="item.deliveryId"
                    :disabled="item.isEditDelivery == 1 || isEditDelivery != 0"
                    @change="changeKD(index)"
                    size="small"
                    placeholder="请选择快递方式"
                  >
                    <el-option
                      v-for="(item2, index2) in item.kdAry"
                      :key="index2"
                      :label="item2.deliveryName"
                      :value="item2.deliveryId"
                      :disabled="item2.isWeb == '0' && item2.status == '1'"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">开票:</div>
                <div class="right">
                  <span v-if="item.isInvoice == 0">开票</span>
                  <span v-else-if="item.isInvoice == 1">不开票</span>
                </div>
              </div>
            </div>

            <div class="line flexStyle2">
              <span class="title">商品信息:</span>
              {{ item.goodsDetail || "暂无" }}
            </div>
          </div>
          <div class="bottom">
            <el-button
              v-if="
                item.status == 0 ||
                  item.status == 1 ||
                  item.status == 2 ||
                  item.status == 3
              "
              size="small"
              style="width:110px;background:#9cbbd8;color:#fff;position:relative;z-index:999;"
              @click="cancelOrderBefore(item)"
            >
              取消子订单
            </el-button>
            <el-button
              size="small"
              style="width:110px;background:#9cbbd8;color:#fff;position:relative;z-index:999;"
              @click="watchOrder(item)"
            >
              查看子订单
            </el-button>
          </div>
        </div>
        <div v-if="status == 1" style="clear:both;">
          <el-row :gutter="24">
            <el-col v-if="isEditDelivery == 0" :span="6">
              <div>
                快递方式：
                <el-select
                  v-model="deliveryId"
                  @change="changeKD(-1)"
                  size="small"
                  style="width:150px;"
                  placeholder="请选择快递方式"
                >
                  <el-option
                    v-for="(item2, index2) in kdList2"
                    :key="index2"
                    :label="item2.deliveryName"
                    :value="item2.deliveryId"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="getSpan2()">
              <el-button
                size="small"
                style="width:110px;background:#9cbbd8;color:#fff;position:relative;z-index:999;"
                @click="chooseKP2"
              >
                选择开票
              </el-button></el-col
            >
            <el-col :span="14" align="right">
              <div class="total" v-if="status == 1">
                <span
                  >商品：<span>{{ to_f(totalGoods) }}元</span></span
                >
                <span
                  >运费：<span>{{ to_f(totalYF) }}元</span></span
                >
                <span
                  >总计：<span>{{ to_f(totalMoney) }}元</span></span
                >
                <el-button
                  v-if="isPrice"
                  size="small"
                  style="width:100px;background:#9cbbd8;color:#fff;position:relative;z-index:999;"
                  @click="choosePrice"
                >
                  去调价
                </el-button>
                <el-button
                  size="small"
                  style="width:100px;background:#9cbbd8;color:#fff;position:relative;z-index:999;"
                  @click="goToPay"
                >
                  去支付
                </el-button>
              </div>
            </el-col></el-row
          >
        </div>
        <div v-if="status == 0" class="total">
          <div v-html="q3Msg"></div>
        </div>
      </div>
      <div class="bottom borderShadow" v-else>{{ tipMsg }}</div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
    <el-dialog title="选择开票" top="28vh" width="400px" :visible.sync="kpShow">
      <el-form :model="formKp">
        <el-form-item label="" label-width="60px">
          <el-radio-group v-model="formKp.isInvoice" @change="submitKP">
            <el-radio label="0">开票</el-radio>
            <el-radio label="1">不开票</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="价格调整" :visible.sync="priceShow" width="400px">
      <el-form :model="form">
        <el-form-item label="产品名称" :label-width="formLabelWidth">
          <el-select v-model="form.goodsId" placeholder="请选择订单产品">
            <el-option
              v-for="item in goodsAry"
              :key="item.goodsId"
              :label="item.goodsName"
              :value="item.goodsId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="产品价格" :label-width="formLabelWidth">
          <el-input v-model="form.price" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePrice">确 定</el-button>
        <el-button @click="priceShow = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import * as math from "mathjs";
import {
  cacelOrderSonRequest,
  kdListRequest,
  kdChooseRequest,
  openTicketRequest,
  shoppingCarNumber,
  interOrderDetailRequest,
  editOrderGoodsPriceRequest,
} from "../../public/js/service";
import { getUserBaseInfoRequest } from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      priceShow: false,
      currentPageInfo: [], // 1.1.currentPageInfo
      token: "", // 1.2.token
      batchId: "", // 1.3.批量订单id
      goodsNumber: 0, // 1.4.购物车商品数量
      formLabelWidth: "120px",
      form: { batchId: null, goodsId: null, price: null },
      goodsAry: [],
      userInfo: {},
      isPrice: false,
      tipMsg: "正在加载数据...",
      kpShow: false, // 1.6.1.开票遮罩层
      deliveryId: null,
      kdList: [],
      kdList2: [],
      formKp: { isInvoice: null },
      notQ3Count: 0,
      q3Msg: "订单已支付",
      isEditDelivery: 1,
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.tabbar
    cFooter: footer, // 2.2.footer
  },

  methods: {
    // 3.methods
    copyText(value) {
      // 3.1.copyText
      let inputObject = document.createElement("input");
      document.body.appendChild(inputObject);
      inputObject.style.visibility = "none";
      inputObject.value = value;
      inputObject.select();
      document.execCommand("copy");

      this.$message({
        showClose: true,
        message: "已复制到剪切板",
        type: "success",
      });
      inputObject.style.display = "none";
    },
    getSpan2() {
      return this.isEditDelivery == 0 ? 4 : 10;
    },
    changeKD(index) {
      // 3.13.选择快递

      if (index < 0) {
        let data = {
          deliveryId: this.deliveryId,
          batchId: this.batchId,
        };
        kdChooseRequest(data).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getCurrentPageInfo();
          }
        });
      }

      if (index >= 0) {
        let data = {
          deliveryId: this.currentPageInfo[index].deliveryId,
          orderId: this.currentPageInfo[index].orderId,
        };

        kdChooseRequest(data).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getCurrentPageInfo();
          }
        });
      }
    },
    getCurrentPageInfo() {
      // 3.2.获取信息
      this.tipMsg = "正在加载数据...";
      interOrderDetailRequest(this.batchId).then((res) => {
        if (res) {
          this.currentPageInfo = res.data;

          if (this.currentPageInfo.length <= 0) {
            this.tipMsg = "暂无数据";
          } else {
            this.notQ3Count = 0;
            for (let j = 0; j < this.currentPageInfo.length; j++) {
              if (this.currentPageInfo[j].status == 2) {
                this.notQ3Count += 1;
              }
              let ss = this.currentPageInfo[j];
              let kdAry = [];
              for (let p = 0; p < this.kdList.length; p++) {
                let dd = this.kdList[p];
                // if (dd.status != "0") {
                //   continue;
                // }
                if (ss.isSupplier == "0") {
                  if (ss.isEditDelivery == "0") {
                    if ((dd.isWebPlat || "0") == "0") {
                      kdAry.push(dd);
                    }
                  } else {
                    if (dd.deliveryId == ss.deliveryId) {
                      kdAry.push(dd);
                    }
                  }
                }
                if (ss.isSupplier == "1") {
                  if ((dd.isWebSupplier || "0") == "0") {
                    kdAry.push(dd);
                  }
                }
              }
              ss.kdAry = kdAry;
            }
            this.q3Msg = "订单已支付";
            if (this.notQ3Count > 0) {
              this.q3Msg +=
                '，还有<span style="color:red;"><b>' +
                this.notQ3Count +
                "</b></span>单待同步";
            }
          }
        }
      });
    },

    goBack() {
      // 3.3.返回
      this.$router.go(-1);
    },
    getKDInfo() {
      // 3.3.获取快递信息
      kdListRequest().then((res) => {
        if (res) {
          this.kdList = res.data;
          let ary = [];
          for (let j = 0; j < res.data.length; j++) {
            let r = res.data[j];
            if (r.isWeb == "0" && r.status == "0") {
              if (
                (r.isWebPlat || "0") == "0" ||
                (r.isWebSupplier || "0") == "0"
              ) {
                ary.push(r);
              }
            }
          }
          this.kdList2 = ary;
        }
      });
    },
    getIsCheckDeliveryId(v) {
      let ff = true;
      for (let j = 0; j < this.kdList2.length; j++) {
        if (this.kdList2[j].deliveryId == v.deliveryId) {
          ff = false;
          break;
        }
      }
      return ff;
    },
    invoiceChange(v) {
      let orderId = this.currentPageInfo[v].orderId;
      let isInvoice = this.currentPageInfo[v].isInvoice;
      let param = { orderId: orderId, isInvoice: isInvoice };
      openTicketRequest(param).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },
    chooseKP2() {
      // 3.7.选择开票
      this.formKp.isInvoice = null;
      this.kpShow = true;
      this.isM2 = 2;
    },
    submitKP(isInvoice) {
      // 3.9.确认开票
      if (this.isM2 == 1) {
        let orderId = this.currentPageInfo[this.chooseKDOrderIndex].orderId;
        let param = { orderId: orderId, isInvoice: isInvoice };
        if (this.currentPageInfo[this.chooseKDOrderIndex] != isInvoice) {
          openTicketRequest(param).then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: res.msg,
              });

              this.currentPageInfo[
                this.chooseKDOrderIndex
              ].isInvoice = isInvoice;
              this.kpShow = false;
              this.chooseKDOrderIndex = 0;
            }
          });
        } else {
          this.$message({
            type: "error",
            message: "重复操作！",
          });
        }
      }

      if (this.isM2 == 2) {
        let param = { batchId: this.batchId, isInvoice: isInvoice };
        openTicketRequest(param).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getCurrentPageInfo();
            this.kpShow = false;
            this.chooseKDOrderIndex = 0;
          }
        });
      }
    },
    watchOrder(item) {
      // 3.4.查看订单详情
      this.$router.push("/orderDetail?orderId=" + item.orderId);
    },

    cancelOrderBefore(item) {
      // 3.5.取消订单之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认取消订单?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.cancelOrder(item);
          }
        },
      });
    },

    cancelOrder(item) {
      // 3.6.取消订单
      cacelOrderSonRequest(item.orderNum).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });

          setTimeout(() => {
            this.getCurrentPageInfo();
          }, 300);
        }
      });
    },
    choosePrice() {
      // 3.11.选择修改商品
      this.priceShow = true;
      let ary = [];
      for (let j = 0; j < this.currentPageInfo.length; j++) {
        let goods = this.currentPageInfo[j].orderItemList;
        if (goods) {
          for (let i = 0; i < goods.length; i++) {
            let goodsId = goods[i].goodsId;
            let item = ary.find((item) => {
              return item.goodsId == goodsId;
            });
            if (item) {
              console.log(item);
            } else {
              ary.push(goods[i]);
            }
          }
        }
      }
      this.goodsAry = ary;
    },
    closePriceShow() {
      // 3.10.关闭开票遮罩层
      this.priceShow = false;
    },
    goToPay() {
      // 3.7.去支付
      if (this.currentPageInfo.length >= 1) {
        this.$router.push(
          "/orderPay?obj2=" + encodeURIComponent(JSON.stringify(this.obj))
        );
      } else {
        this.$message.error("无法支付");
      }
    },

    getGoodsNumber() {
      // 3.8.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },

    printFn(value) {
      // 3.9.精度算数
      const precision = 14;
      return Number(math.format(value, precision));
    },
    savePrice() {
      // 3.12
      this.form.batchId = this.batchId;
      let _this = this;

      this.$msgbox({
        title: "提示",
        message: "您确定要调整价格?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.editOrderGoodsPrice(_this.form);
          }
        },
      });
    },
    editOrderGoodsPrice(item) {
      let _this = this;
      editOrderGoodsPriceRequest(item).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          _this.priceShow = false;
          setTimeout(() => {
            this.getCurrentPageInfo();
          }, 300);
        }
      });
    },
    getUserInfo() {
      // 3.4.获取用户信息
      getUserBaseInfoRequest().then((res) => {
        if (res) {
          this.userInfo = res.data;
          if (this.userInfo.isModifyPrice == "0") {
            this.isPrice = true;
          }
          localStorage.userInfo = JSON.stringify(res.data);
        }
      });
    },
  },

  mounted() {
    // 4.mounted
    if (this.$route.query.obj) {
      let obj = JSON.parse(decodeURIComponent(this.$route.query.obj));
      this.obj = obj;
      this.batchId = obj.batchId;
      this.batchName = obj.batchName;
      this.status = obj.status || 1;

      if (localStorage.token) {
        this.token = localStorage.token;

        this.getKDInfo();

        this.getCurrentPageInfo();

        this.getGoodsNumber();

        this.getUserInfo();
      }
    }
  },

  computed: {
    // 5.computed
    totalGoods() {
      // 5.1.totalGoods
      let res = 0;
      this.currentPageInfo.forEach((item) => {
        if (item.status != 4) {
          res += item.moneyGoods ? item.moneyGoods : 0;
        }
      });
      return this.printFn(res);
    },

    totalYF() {
      // 5.2.totalYF
      let res = 0;
      this.currentPageInfo.forEach((item) => {
        if (item.status != 4) {
          res += item.moneyYun ? item.moneyYun : 0;
        }
      });
      return this.printFn(res);
    },

    totalMoney() {
      // 5.2.totalMoney
      let res = 0;
      this.currentPageInfo.forEach((item) => {
        if (item.status != 4) {
          res += item.money ? item.money : 0;
        }
      });
      return this.printFn(res);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./interOrderDetail.scss";
</style>
